'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.default = function () {
    var _this = this;

    (0, _jquery2.default)('input[numbers-only]').on('keyup', function () {
        var val = (0, _jquery2.default)(this).val();
        val = val.replace(/\D/g, '').replace(/^0+/, '');
        ;
        if ((0, _jquery2.default)(this).val() !== val) {
            (0, _jquery2.default)(this).val(val);
        }
    });

    (0, _jquery2.default)('input[numbers-only]').on('change', function () {
        toggleClassByValue(_this);
    });

    var inputArray = document.querySelectorAll('input[commission-catalog-input]');
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(inputArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var inp = _step.value;

            if (inp.registered === true) continue;

            inp.addEventListener('keyup', function (e) {
                return amountInputPressKey(e, true);
            });
            inp.addEventListener('keydown', function (e) {
                return amountInputPressKey(e);
            });
            inp.addEventListener('keypress', function (e) {
                return amountInputPressKey(e);
            });
            inp.registered = true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    function amountInputPressKey(event, performUpdate) {
        if (event.keyCode !== 13) return;

        if (performUpdate) {
            // update window.commissionCatalogProducts
            var input = event.target;
            var productId = _common2.default.testIntInString(input.dataset.productId) ? parseInt(input.dataset.productId) : 0;
            var amount = _common2.default.testIntInString(input.value) ? parseInt(input.value) : 0;
            updateSelectedCommissionCatalogProducts(productId, amount);

            // "click" on the button "Buy all"
            var buyAllBtn = document.querySelector('a[commission-catalog-buy-all]');
            if (buyAllBtn) buyAllBtn.click();
        }
        event.preventDefault();
    }

    function updateSelectedCommissionCatalogProducts(productId, amount) {
        // update amount for product or create new item for product and amount
        window.selectedCommissionCatalogProducts = window.selectedCommissionCatalogProducts || [];
        var updated = false;
        window.selectedCommissionCatalogProducts.find(function (e, i) {
            if (e.productId === productId) {
                window.selectedCommissionCatalogProducts[i].amount = amount;
                updated = true;
            }
        });
        if (!updated) window.selectedCommissionCatalogProducts.push({ productId: productId, amount: amount });
    }

    document.querySelectorAll('input[commission-catalog-input]').forEach(function (input) {
        return input.addEventListener('blur', function (event) {
            var input = event.target;
            var productId = _common2.default.testIntInString(input.dataset.productId) ? parseInt(input.dataset.productId) : 0;
            var amount = _common2.default.testIntInString(input.value) ? parseInt(input.value) : 0;
            updateSelectedCommissionCatalogProducts(productId, amount);
        });
    });

    var buyAllBtn = document.querySelector('a[commission-catalog-buy-all]');
    if (buyAllBtn) // need to check it because this code is executed also in commission cart, but there's no "Buy all" button out there
        buyAllBtn.addEventListener('click', function (event) {
            // send product to commission cart & update CSS class on all visible inputs
            (window.selectedCommissionCatalogProducts || []).forEach(function (i) {
                return sendToCommissionCart(i.productId, i.amount);
            });
            document.querySelectorAll('input[commission-catalog-input]').forEach(function (input) {
                return toggleClassByValue(input);
            });
        });

    (0, _jquery2.default)('#hideAdditionalInfo').on('click', function (e) {
        e.stopImmediatePropagation();
        var input = (0, _jquery2.default)(this).find('input[type="checkbox"]')[0];
        var checked = (0, _jquery2.default)(input).prop('checked');

        (0, _jquery2.default)('td[hide-commission-catalog-column], th[hide-commission-catalog-column]').each(function (i) {
            if (!checked) {
                (0, _jquery2.default)(this).show();
            } else {
                (0, _jquery2.default)(this).hide();
            }
        });

        (0, _jquery2.default)(input).prop('checked', !checked);
        return false;
    });

    (0, _jquery2.default)('a[commission-catalog-send-order]').on('click', function (e) {
        e.stopImmediatePropagation();

        _jquery2.default.ajax({
            type: "POST",
            url: "/CommissionCatalog/SendOrder",
            success: function success(data) {
                if (data.result.success) {
                    window.location.href = data.result.url;
                } else {
                    (0, _sweetalert2.default)(data.result.message);
                }
            }
        });
    });

    function sendToCommissionCart(productId, amount) {
        var model = {
            ProductId: productId,
            Amount: amount
        };

        _jquery2.default.ajax({
            type: "POST",
            contentType: "application/json; charset=utf-8",
            url: '/CommissionCatalog/UpdateCommissionCartItem',
            data: (0, _stringify2.default)({ model: model }),
            success: function success(data, textStatus, xhr) {}
        });
    }

    function toggleClassByValue(element) {
        if (parseInt((0, _jquery2.default)(element).val()) > 0) {
            (0, _jquery2.default)(element).closest('form').addClass('added-to-cart');
        } else {
            (0, _jquery2.default)(element).closest('form').removeClass('added-to-cart');
        }
    }
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = require('prop-types');

var _sweetalert = require('sweetalert');

var _sweetalert2 = _interopRequireDefault(_sweetalert);

var _common = require('../utils/common');

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/commissionCatalog.js
// module id = 934
// module chunks = 0